var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMab2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 104,
    viewBox: "0 0 116 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2028_768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 48C40 38.0589 48.0589 30 58 30C67.9411 30 76 38.0589 76 48C76 57.9411 67.9411 66 58 66C48.0589 66 40 57.9411 40 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.46 51.9C55.74 50.7933 56.7467 49.8867 57.48 49.18C58.2267 48.46 58.8467 47.7133 59.34 46.94C59.8333 46.1667 60.08 45.3933 60.08 44.62C60.08 43.82 59.8867 43.1933 59.5 42.74C59.1267 42.2867 58.5333 42.06 57.72 42.06C56.9333 42.06 56.32 42.3133 55.88 42.82C55.4533 43.3133 55.2267 43.98 55.2 44.82H53C53.04 43.3 53.4933 42.14 54.36 41.34C55.24 40.5267 56.3533 40.12 57.7 40.12C59.1533 40.12 60.2867 40.52 61.1 41.32C61.9267 42.12 62.34 43.1867 62.34 44.52C62.34 45.48 62.0933 46.4067 61.6 47.3C61.12 48.18 60.54 48.9733 59.86 49.68C59.1933 50.3733 58.34 51.18 57.3 52.1L56.4 52.9H62.74V54.8H53.02V53.14L54.46 51.9Z",
    fill: "#020202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2028_768",
    x: 0,
    y: 0,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0470588 0 0 0 0 0.0666667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2028_768"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2028_768",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMab2);
export default __webpack_public_path__ + "static/media/mab2.4f6183ceab453fcf6e9c9cd84ac7f5a7.svg";
export { ForwardRef as ReactComponent };